import { MeiliSearch } from "meilisearch";

const postCache: { [ index: number ]: any } = {};
const postTermsCache: { [ index: string ]: any } = {};

const search = async (category?: string, filters?: string[]) => {
	/*
	if (
		!process.env.REACT_APP_MEILISEARCH_HOST ||
		!process.env.REACT_APP_MEILISEARCH_KEY ||
		!process.env.REACT_APP_MEILISEARCH_INDEX_NAME
	)
		return console.error("MeiliSearch credentials not found");
	const client = new MeiliSearch({
		host: process.env.REACT_APP_MEILISEARCH_HOST,
		apiKey: process.env.REACT_APP_MEILISEARCH_KEY,
	});

	const index = client.index(process.env.REACT_APP_MEILISEARCH_INDEX_NAME);
       */
	let filterString = "";
	if (category) {
		filterString += `category='${category}'`;
	}
	filters?.forEach((filter) => {
		if (!!filterString) filterString += " AND";
		filterString += ` ${filter}`;
	});

	const response = await window.fetch( `/wp-json/teradyne/product-finder?${ filterString }` ).then( response => response.json() );

	/*
	let response = await index.search("", {
		filter: filterString,
		sort: ['weight:asc'],
		limit: 1000,
	});

	if ( ! response
		|| !response.hits
		|| !response.hits.length
	) {
//		if ( ! window.Object.keys( postTermsCache ).length ) {
//			const finderproductCategories = await window.fetch( `/wp-json/wp/v2/product_finder_cat?per_page=100` ).then( response => response.json() );
//			finderproductCategories.forEach( ( term: any ) => {
//				postTermsCache[ term.name ] = term;
//			} );
//		}

		filterString = '';
		
//		if ( category && postTermsCache[ category ] && postTermsCache[ category ].id ) {
//			filterString = `&product_finder_cat=${postTermsCache[ category ].id}`;
//		}

		if ( category
			&& window.productFinderTaxonomyTerms
			&& window.productFinderTaxonomyTerms.product_finder_cat
			&& window.productFinderTaxonomyTerms.product_finder_cat[ category ]
		) {
			filterString = `&product_finder_cat=${ window.productFinderTaxonomyTerms.product_finder_cat[ category ] }`;
		}
		if ( filters
		    && filters.length
		) {
			filters.forEach( ( filter ) => {
			if (!!filterString) filterString += " AND";
				const filterComponenets = filter.split('=');
				const filterTaxonomy = `pt_${ filterComponenets[0]}`;
				const filterTermName = filterComponenets[1].replace(/^\'/, '').replace(/\'$/, '');
				if ( filterTaxonomy
					&& filterTermName
					&& window.productFinderTaxonomyTerms
					&& window.productFinderTaxonomyTerms[ filterTaxonomy ]
					&& window.productFinderTaxonomyTerms[ filterTaxonomy ][ filterTermName ]
				) {
					filterString += `&${ filterTaxonomy }=${ window.productFinderTaxonomyTerms[ filterTaxonomy ][ filterTermName ] }`;
				}
			});
		}
		const finderproducts = await window.fetch( `/wp-json/wp/v2/finderproducts?orderby=title&order=asc&per_page=100${ filterString }` ).then( response => response.json() );
		if ( finderproducts && finderproducts.length ) {
			response.hits = finderproducts.map( ( post: any ) => {
				return {
					...post,
//					image: post.featured_media,
					model: post.acf && post.acf['product-model'] ? post.acf['product-model'] : null,
					name: post.acf && post.acf['product-name'] ? post.acf['product-name'] : null,
					description: post.acf && post.acf['product_description'] ? post.acf['product_description'] : null,
					typical_test_applications:  post.acf && post.acf['typical_test_applications_table'] ? post.acf['typical_test_applications_table'] : null,
					brochure:  post.acf && post.acf['product-brochure'] ? post.acf['product-brochure'] : null,
					supported_bus_table:  post.acf && post.acf['supported_bus_table'] ? post.acf['supported_bus_table'] : null,
					capabilities:  post.acf && post.acf['capabilities_table'] ? post.acf['capabilities_table'] : null,
				}
			} );
		}
	}

	if ( response
		&& response.hits
		&& response.hits.length
	) {
		const postIds = response.hits.map( ( item ) => item.id );

		if ( postIds ) {
			const uncahedPostIds: number[] = [];

			postIds.forEach( ( id: number ) => {
				if ( ! postCache[ id ] ) {
					uncahedPostIds.push( id );
				}
			} );

			if ( uncahedPostIds && uncahedPostIds.length ) {
				const posts = await window.fetch( `/wp-json/wp/v2/finderproducts?_fields=id,acf&include=${ uncahedPostIds.join( ',' ) }&per_page=${ uncahedPostIds.length }` ).then( response => response.json() );

				posts.forEach( ( post: any ) => {
					postCache[ post.id ] = post;
				} );
			}
		}

		response.hits.forEach( ( hit, index: number ) => {
			if ( hit
				&& hit.id
				&& postCache[ hit.id ]
			) {
				for ( let key in postCache[ hit.id ] ) {
					if ( ! hit[ key ] ) {
						response.hits[ index ][ key ] = postCache[ hit.id ][ key ];
					}
				}
			}
		} );
	}
       */

	return response;
};

export default search;
